// Підписи часу для кліпів — окремо від utils/clip.js: той тягне mediabunny
// (рушій нарізки), а ці два рядки потрібні й списку кліпів, де нічого не
// ріжуть.

export const formatClipTime = (seconds, tenths = false) => {
  const clamped = Math.max(0, Number(seconds) || 0)
  const total = Math.floor(clamped)
  const h = Math.floor(total / 3600)
  const m = Math.floor((total % 3600) / 60)
  const s = total % 60
  const tail = tenths ? `.${Math.floor((clamped - total) * 10)}` : ''
  return h > 0
    ? `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}${tail}`
    : `${m}:${String(s).padStart(2, '0')}${tail}`
}

export const parseClipTime = (text) => {
  const parts = String(text).trim().split(':')
  if (parts.length < 1 || parts.length > 3) return null
  if (parts.some((p) => !/^\d+(\.\d+)?$/.test(p))) return null
  return parts.reduce((acc, p) => acc * 60 + Number(p), 0)
}

/** «5 хв тому», «3 дні тому», а старше за місяць — датою */
export const formatAgo = (iso) => {
  const date = new Date(iso)
  const ms = Date.now() - date.getTime()
  if (Number.isNaN(ms)) return ''
  const min = Math.floor(ms / 60000)
  if (min < 1) return 'щойно'
  if (min < 60) return `${min} хв тому`
  const hours = Math.floor(min / 60)
  if (hours < 24) return `${hours} год тому`
  const days = Math.floor(hours / 24)
  if (days < 31) return `${days} дн. тому`
  return date.toLocaleDateString('uk-UA', { day: 'numeric', month: 'short', year: 'numeric' })
}
